<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<mat-card appearance="raised" style="padding: 5px 0; height: 100%;">
    <div>
        <!--span><p class="component-label"><a class="href-link" [routerLink]="['/devices']" [queryParams]="getHeaderQueryParams()">Endpoint Overview</a></p></span-->
        <p class="component-label">
          <span class="draggable">{{fEndpointOverview}}</span>
        </p>
        <hr>
        <div *ngIf="dashboardOverviewLoaded">
            <span class="dashboard-overview-loaded"></span>
        </div>
    </div>
    <div class="icon-and-list">
        <div class="icon-area">
            <span class="mdi mdi-monitor desktop-icon"></span>
            <div *ngIf="!(loadingEndpoints$ | async); else endpointsTotalSkeleton;" class="total-number item-color">{{ totalDevices }}</div>
            <ng-template #endpointsTotalSkeleton>
                <ngx-skeleton-loader
                  count="1"
                  appearance="line"
                  [theme]="largeValueStyle">
                </ngx-skeleton-loader>
            </ng-template>
        </div>
        <div class="list-area">
          <ul>
            <li class="list-item">
                <div class="list-info">
                    <span class="item-label">{{fEndpointConnected}}</span>
                    <span *ngIf="!(loadingEndpoints$ | async); else loadingConnected;" class="item-value item-color" attr.aria-label="Endpoints Connected {{ connected }}" id="Connected">{{ connected }}</span>
                    <ng-template #loadingConnected>
                        <ngx-skeleton-loader
                          count="1"
                          appearance="line"
                          [theme]="valueStyle">
                        </ngx-skeleton-loader>
                    </ng-template>
                </div>
            </li>
            <li class="list-item">
                <div class="list-info">
                    <span class="item-label">{{fEndpointOffline}}</span>
                    <span *ngIf="!(loadingEndpoints$ | async); else loadingOffline;" class="item-value item-color" attr.aria-label="Endpoints Offline {{ offline }}" id="Offline">{{ offline }}</span>
                    <ng-template #loadingOffline>
                        <ngx-skeleton-loader
                          count="1"
                          appearance="line"
                          [theme]="valueStyle">
                        </ngx-skeleton-loader>
                    </ng-template>
                </div>
            </li>
            <li class="list-item">
                <div class="list-info">
                    <span class="item-label">{{fEndpointUpgrade}}</span>
                    <span *ngIf="!(loadingEndpoints$ | async); else loadingEligible;">
                      <span *ngIf="eligible > 0" class="item-value red-color" attr.aria-label="Eligible for upgrade{{ eligible }}" id="Eligible For Upgrade">{{ eligible }}</span>
                      <span *ngIf="eligible == 0" class="item-value item-color">{{ eligible }}</span>
                    </span>
                    <ng-template #loadingEligible>
                        <ngx-skeleton-loader
                          count="1"
                          appearance="line"
                          [theme]="valueStyle">
                        </ngx-skeleton-loader>
                    </ng-template>
                </div>
            </li>
            <li class="list-item">
                <div class="list-info">
                    <span class="item-label">{{fEndpointNoProt}}</span>
                    <span *ngIf="!(loadingEndpoints$ | async); else loadingNoProtection" class="item-value item-color" attr.aria-label="Endpoints With No Protection {{ noProtection }}" id="Devices With No Protection">{{ noProtection }}</span>
                    <ng-template #loadingNoProtection>
                        <ngx-skeleton-loader
                          count="1"
                          appearance="line"
                          [theme]="valueStyle">
                        </ngx-skeleton-loader>
                    </ng-template>
                </div>
            </li>
            <li class="list-item">
                <div class="list-info">
                    <span class="item-label">{{fEndpointUnconfig}}</span>
                    <span *ngIf="!(loadingEndpoints$ | async); else loadingUnconfigured;">
                      <span *ngIf="unconfigured > 0" class="item-value red-color" attr.aria-label="Endpoints with Unconfigured Secure Drives {{ unconfigured }}" id="Unconfigured Secure Drives">{{ unconfigured }}</span>
                      <span *ngIf="unconfigured == 0" class="item-value item-color">{{ unconfigured }}</span>
                    </span>
                    <ng-template #loadingUnconfigured>
                        <ngx-skeleton-loader
                          count="1"
                          appearance="line"
                          [theme]="valueStyle">
                        </ngx-skeleton-loader>
                    </ng-template>
                </div>
            </li>
          </ul>
        </div>
    </div>
    <div class="component-footnote">
        <span>{{fEndInfo}}</span>
    </div>
</mat-card>